// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// eslint-disable-next-line
import Vue from 'vue';
import moment from 'moment';
import App from './App';
import router from './router';
import axios from 'axios';
import { ACCESS_TYPE } from '@/constants';

const vhtml = window.vhtml;
Vue.use(vhtml);
vhtml.install(Vue);

try {
    let iconpath = 'https://cdn3.codesign.qq.com/icons/XzKaDZdEa7j2GPL/latest/iconfont.js';
    vhtml.Icon.setDefaultRemoteSrc && vhtml.Icon.setDefaultRemoteSrc(iconpath);
} catch (e) {
    console.log('load remote icon error');
}

Vue.config.productionTip = false;
Vue.prototype.moment = moment;

router.beforeEach((to, from, next) => {
    document.title = to.meta.title || 'BESTdisc智能客服';
    if (to.name && window.$initType !== to.name) {
        window.location.reload();
    }
    next();
});

let webIMType; // 后端ws识别的端类型
let webIMSource; // 前端区分UI交互的端类型

webIMType = [5];
window.$initTypeKey = 5;
webIMSource = 'client';

Vue.prototype.webIMSource = webIMSource;

Object.defineProperty(window, 'userType', {
    writable: false,
    enumerable: false,
    configurable: false,
    value: 2
});

window.$initType = 'AiServer';

console.log('【init msg-------ACCESS_TYPE---->】', ACCESS_TYPE);
let tokenGet = webIMType.map(type => {
    return new Promise(async (resolve, reject) => {
        let demoToken = '';
        // 无论使用哪种模式，都获取token
        try {
            console.log('【开始获取token】');
            const res = await axios.get('https://www.bestdisc.net/gwapi/index/ai_token/from/ajax');
            console.log('【token获取接口返回状态】', res.status);
            console.log('【token获取接口返回数据】', res.data);
            if (res && res.data) {
                console.log('【retInt】', res.data.retInt);
                console.log('【retRes】', res.data.retRes);
                if (res.data.retInt === 1 && res.data.retRes) {
                    // 从返回数据中提取token
                    if (typeof res.data.retRes === 'object' && res.data.retRes.token) {
                        demoToken = res.data.retRes.token;
                        console.log('【提取到的token字符串】', demoToken);
                        console.log('【token类型】', typeof demoToken);
                    } else {
                        demoToken = res.data.retRes;
                        console.log('【提取到的token】', demoToken);
                        console.log('【token类型】', typeof demoToken);
                    }
                } else {
                    console.error('【token获取失败】retInt不为1或retRes为空');
                }
            } else {
                console.error('【token获取失败】返回数据为空');
            }
        } catch (e) {
            console.error('【token获取异常】', e);
        }
        let result = {
            type: type,
            token: demoToken,
            access: ACCESS_TYPE
        };
        console.log('【最终使用的token】', result);
        resolve(result);
    });
});

Promise.all(tokenGet).then(res => {
    Object.defineProperty(window, 'webimToken', {
        writable: false,
        enumerable: false,
        configurable: false,
        value: res
    });
    initVue();
}).catch(e => {
    console.error('获取token失败:', e);
    // 即使token获取失败，也创建Vue实例
    window.webimToken = [];
    initVue();
});

function initVue () {
    if (ACCESS_TYPE === 'ws') {
        (async () => {
            try {
                let mixin = await import('@/manage/index');
                Vue.mixin(mixin);
                /* eslint-disable no-new */
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            } catch (e) {
                console.error('加载WebSocket mixin失败:', e);
                // 加载失败时直接创建Vue实例
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            }
        })();
    } else {
        (async () => {
            try {
                let sseMixin = await import('@/manage/sse');
                Vue.mixin(sseMixin);
                /* eslint-disable no-new */
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            } catch (e) {
                console.error('加载SSE mixin失败:', e);
                // 加载失败时直接创建Vue实例
                new Vue({
                    el: '#app',
                    router,
                    render (h) {
                        return h(App);
                    }
                }).$mount('#app');
            }
        })();
    }
}



// WEBPACK FOOTER //
// ./src/main.js